import React from "react";
import {Platform} from "react-native";
import {View, Text, Stack} from "@unibuddy/patron";
import RelativeButtonLink from "ubcommunity-shared/src/Navigation/RelativeButtonLink/RelativeButtonLink";
import {ButtonLink} from "ubcommunity-shared/src/General/ButtonLink/ButtonLink";
import {ErrorSvg} from "ubcommunity-shared/src/General/Errors/ErrorSvg";
import {Routes} from "ubcommunity-shared/src/constants/routes";

type SSOErrorProps = {
    slug?: string;
};

export const SSOErrorStrings = {
    title: "Oh no! Something went wrong. Please try again.",
    buttonText: "Back to login",
};

export const SSOError = ({slug}: SSOErrorProps) => {
    return (
        <View
            flex={1}
            marginY="large"
            alignItems="center"
            justifyContent="center"
            paddingX="medium"
        >
            <Stack space="large">
                <View flex={1} alignItems="center">
                    <ErrorSvg size={150} />
                </View>
                <Text size="large">{SSOErrorStrings.title}</Text>
                {Platform.select({
                    web: (
                        <RelativeButtonLink
                            block
                            color="primary"
                            to={slug ? `/u/${slug}/auth/login` : `/u/auth/login`}
                        >
                            <Text align="center" color="white">
                                {SSOErrorStrings.buttonText}
                            </Text>
                        </RelativeButtonLink>
                    ),
                    native: (
                        <ButtonLink block color="primary" to={Routes.LOGIN}>
                            <Text align="center" color="white">
                                {SSOErrorStrings.buttonText}
                            </Text>
                        </ButtonLink>
                    ),
                })}
            </Stack>
        </View>
    );
};
